import * as React from 'react';
import styled from 'styled-components';

const BtnLnk = styled.a`
    padding: .2rem 1rem;
    border-radius: 3px;
    font-weight: 600;
    font-size: 13px;
`;
const Input = styled.input`
    width: 70px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    padding: 5px 7px;
    font-size: inherit;
    border-radius: 3px;
`;
interface IProps {
    currentIndex: number,
    totalIndex: number,
    showInput?: boolean,
    onClick: (direction:number, isExactTarget?: boolean) => void
}
export const NavCountBar = (props:IProps) => {
    if(props.showInput){
        return (
            <div className="align-text-right">
                <BtnLnk className={props.currentIndex > 1?'':'disabled'} onClick={()=> {if(props.currentIndex > 1){ props.onClick(props.currentIndex-1 < 1? 1: props.currentIndex-1)}}}><i className="fas fa-arrow-left" /></BtnLnk>
                    <Input min={1} max={props.totalIndex} type="number" value={props.currentIndex} onChange={(ev)=>{ 
                        const cValue = Number(ev.currentTarget.value);
                        if(cValue >= 1 && cValue <= props.totalIndex){
                            props.onClick(Number(ev.currentTarget.value), true)
                        }else if(cValue < 1){
                            props.onClick(Number(1), true)
                        }else{
                            props.onClick(Number(props.totalIndex), true)
                        }
                    }
                    } /> of {props.totalIndex}
                <BtnLnk className={props.totalIndex > props.currentIndex?'':'disabled'} onClick={() => {if(props.totalIndex > props.currentIndex){ props.onClick(props.currentIndex+1 > props.totalIndex? props.totalIndex: props.currentIndex+1)}}}><i className="fas fa-arrow-right" /></BtnLnk>
            </div>
        )
    }else {
        return(
            <div className="align-text-right">
                {props.currentIndex > 1 && <BtnLnk onClick={()=> {props.onClick(-1)}}><i className="fas fa-arrow-left" /></BtnLnk>}
                    {!props.showInput && props.currentIndex} of {props.totalIndex}
                {props.totalIndex > props.currentIndex && <BtnLnk onClick={() => {props.onClick(1)}}><i className="fas fa-arrow-right" /></BtnLnk>}
            </div>
        )
    }
}